import React, { Component } from 'react'
import { connect } from 'react-redux'

import { dirtyRead, doc } from 'selectors/common'
import { currentUserAvatar } from 'selectors/attachments'

import dataActions from 'actions/dataActions'
import attachmentActions from 'actions/attachmentActions'

import Avatar from 'material-ui/Avatar'
import TextField from 'material-ui/TextField'

let select = dirtyRead(
	(state, props) => {
		return {
			owner: doc(state, props.ownerID)
		  , avatar: currentUserAvatar(state)
		}
	}
)

export class MainInfo extends Component{
	render(){
		let { props } = this
		return(
			<div style={{display: "flex", justifyContent: "center", marginTop: "50px"}}>
				{
					(props.avatar)?
						<Avatar
							size={150}
							src={props.avatar.url}
							style={{
								marginRight: "100px"
							}}
						/>
						:
						<Avatar size={150} style={{margin: "5%"}}>
							{props.owner.firstName.replace(/LLC/gi,"").replace(/\ |&/gi,"").replace(/^_+|_+$|__/gi, "").replace(/[a-z]/g, '')}
						</Avatar>
				}
				<div>
					<TextField
						floatingLabelText="Name"
						defaultValue={props.owner.firstName}
						fullWidth={true}
						onBlur={(evt) =>{
							props.STAGE({
								_id: props.ownerID
							  , firstName: evt.target.value
							})
						}}
					/>
					<TextField
						floatingLabelText="Email"
						defaultValue={props.owner.email}
						fullWidth={true}
						type="email"
						onBlur={(evt) =>{
							props.STAGE({
								_id: props.ownerID
							  , email: evt.target.value
							})
						}}
					/>
					<TextField
						floatingLabelText="Cell Number"
						defaultValue={props.owner.cellNumber}
						fullWidth={true}
						type="tel"
						onBlur={(evt) =>{
							props.STAGE({
								_id: props.ownerID
							  , cellNumber: evt.target.value
							})
						}}
					/>
				</div>
			</div>
		)
	}
}

export default connect(select, {...dataActions, ...attachmentActions})(MainInfo)



// WEBPACK FOOTER //
// ./src/routes/landlord/profile/MainInfo.js